export type AdItemData = {
  adId: number;
  isChecked: boolean;
};
export type EventItemData = {
  id: number;
  isChecked: boolean;
};
export const adItemDataArr = [
  { adId: 1, isChecked: true },
  { adId: 2, isChecked: false },
  { adId: 3, isChecked: false },
  { adId: 4, isChecked: false },
];
export const eventItemDataArr = [
  { id: 1, isChecked: true },
  { id: 2, isChecked: false },
  { id: 3, isChecked: false },
  { id: 4, isChecked: false },
];
